import React from 'react';
import AppLayout from '../../layout/app.layout';
import OzyPlaySettings from '../../components/advertisers/ozyplay-settings.component';

const OzyPlaySettingsView = () => {
  const pageTitle = 'Advertising / Whale TV Settings';

  return (
    <AppLayout pageTitle={pageTitle}>
      <OzyPlaySettings />
    </AppLayout>
  );
};

export default OzyPlaySettingsView;
